<template>
  <div>
    <img v-if="msg.srcUrl==='loading'" class="img-loading" src="@/assets/images/imgLoad.png" alt="加载中..." />
    <div v-else>
      <div :class="['file-msg-wrapper',{'is-self-file':isSelf}]" @click="handleClickDownldFile">
        <img v-if="msg.msgTip&&msg.msgTip==='isDelete'" style="width: 16px;height: auto;position: absolute;top:45%;left:-26px;" src="@/assets/images/field.png" alt="上传失败" />
        <div class="file-icon-wrapper">
          <img :src="fileImgUrl" />
        </div>
        <div class="file-name-wrapper">
          <p class="file-name">{{ msg.fileName }}</p>
          <p class="file-size">{{ fileSize }}M</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
/**
   * 文件类型消息显示
   */
export default {
  name: 'FileMsg',
  props: {
    msg: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSelf() {
      const { sendType } = this.msg
      return !(sendType && sendType.toUpperCase() === 'SEND' || sendType.toUpperCase() === 'AUTO_REPLY')
    },
    fileImgUrl() {
      const type = this.msg.srcUrl.split('.')[1]
      const showFileImage = [
        { type: 'docx', url: require('@/assets/fileMsg/doc.png') },
        { type: 'doc', url: require('@/assets/fileMsg/doc.png') },
        { type: 'ppt', url: require('@/assets/fileMsg/ppt.png') },
        { type: 'pptx', url: require('@/assets/fileMsg/ppt.png') },
        { type: 'xls', url: require('@/assets/fileMsg/xls.png') },
        { type: 'xlsx', url: require('@/assets/fileMsg/xls.png') },
        { type: 'zip', url: require('@/assets/fileMsg/zip.png') },
        { type: 'rar', url: require('@/assets/fileMsg/zip.png') },
        { type: 'txt', url: require('@/assets/fileMsg/txt.png') },
        { type: 'music', url: require('@/assets/fileMsg/music.png') },
        { type: 'wma', url: require('@/assets/fileMsg/music.png') },
        { type: 'mp3', url: require('@/assets/fileMsg/music.png') }
      ]
      const flag = showFileImage.find(c => c.type === type)
      if (flag) {
        return flag.url
      }
      return require('@/assets/fileMsg/any.png')
    },
    fileSize() {
      return (this.msg.fileSize / 1024 / 1024).toFixed(2)
    }
  },
  methods: {
    handleClickDownldFile() {
      const { srcUrl } = this.msg
      const downUrl = process.env.VUE_APP_CHAT_SERVER + '/fastDfs/download?recordFile=' + srcUrl
      axios({
        method: 'get',
        url: downUrl, // 请求地址
        responseType: 'blob' // 表明返回服务器返回的数据类型
      }).then(res => {
        const content = res.data
        const blob = new Blob([content])
        const fileName = this.msg.fileName
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus">
  .file-msg-wrapper
    width 220px
    padding 8px
    box-sizing border-box
    display flex
    align-items center
    background #F5F8F8
    position relative
    &.is-self-file
      display inline-block
      .file-name-wrapper
        position relative
        top -8px
        width 140px
        margin-left 5px
    .file-name-wrapper
      margin-left 12px
      display inline-block
      text-align left
      .file-name
        max-width 120px
        font-size 14px
        font-family PingFangSC-Regular, PingFang SC
        font-weight 400
        color #333333
        line-height 20px
        margin-bottom 6px
        overflow: hidden;
        white-space nowrap
        text-overflow: ellipsis;
      .file-size
        font-size 12px
        font-family PingFangSC-Regular, PingFang SC
        font-weight 400
        color #999999
        line-height 18px
    .file-icon-wrapper
      width 52px
      height 52px
      display inline-block
      img
        width 52px
        height 52px
</style>
